import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'

function randomSeed() {
  return Math.random() * 10000;
}

import { MeshStandardMaterial, Color } from 'three'

export function Flame({ seed, color = null, emissiveIntensity = 1.5, ...props }) {
  const { nodes, materials } = useGLTF('/models/CandleFlame.glb')
  const flameRef = useRef()
  // Use provided seed or generate a random one
  const seedRef = useRef(seed !== undefined ? seed : randomSeed())
  let t = 0;
  // Create a persistent material override if color is provided
  const colorMaterial = useRef(null)
  if (color && !colorMaterial.current) {
    colorMaterial.current = new MeshStandardMaterial({
      color: new Color(color),
      emissive: new Color(color),
      emissiveIntensity: emissiveIntensity,
      transparent: true,
      opacity: 0.95,
    })
  }
  
  useFrame((_, delta) => {
    if (flameRef.current) {
      t += delta;
      // Flicker based on time and unique seed
      const s = 0.9 + (Math.sin(t * 8 + seedRef.current) + Math.random() * 0.5) * 0.05;
      flameRef.current.scale.set(s, s, s)
      // Small random rotation flicker
      const rotX = Math.sin(t * 6 + seedRef.current * 0.5) * 0.07 * Math.random();
      const rotY = Math.cos(t * 7 + seedRef.current * 0.7) * 0.07 * Math.random();
      const rotZ = Math.sin(t * 5 + seedRef.current * 0.9) * 0.07 * Math.random();
      flameRef.current.rotation.set(rotX, rotY, rotZ);
    }
  })
  return (
    <group {...props} dispose={null}>
      <group name="Scene">
        <mesh
          ref={flameRef}
          name="Flame"
          castShadow
          receiveShadow
          geometry={nodes.Flame.geometry}
          material={colorMaterial.current ? colorMaterial.current : materials.Fire}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/CandleFlame.glb')